<div class="container">
  <!-- <div class="title">צור קמפיין</div> -->

  <form [formGroup]="campaignForm">
    <div class="add-task-container">

    <mat-form-field appearance="outline" floatLabel="always" class="compact-form compact-form-wide">
      <mat-label>מערכת</mat-label>
      <mat-select formControlName="application" (selectionChange)="onApplicationChange($event.value)">
        @for (item of lutTables().lut_applications; track item) {
          <mat-option [value]="item">
            {{ item.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="compact-form compact-form-wider">
      <mat-label>סוג פעילות</mat-label>
      <mat-select formControlName="engagementType">
        @for (item of engagementTypeList(); track item) {
          <mat-option [value]="item">
            {{ item.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="campaign-name compact-form">
      <mat-label>שם הקמפיין</mat-label>
      <input matInput formControlName="campaignName" />
    </mat-form-field>

    </div>

    <div class="add-task-container">

    <mat-form-field appearance="outline" floatLabel="always" class="compact-form compact-form-mid">
      <mat-label>יחידה</mat-label>
      <mat-select formControlName="ownerUnitId">
        @for (item of ownerUnits(); track item) {
          <mat-option [value]="item.id">
            {{ item.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="compact-form compact-form-mid">
      <mat-label>אזור</mat-label>
      <mat-select formControlName="regionId">
        @for (item of lutTables().lut_regions; track item) {
          <mat-option [value]="item.id">
            {{ item.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="compact-form compact-form-mid" [style.visibility]="isTgselected ? 'hidden' : 'visible'">
      <mat-label>מגדר</mat-label>
      <mat-select formControlName="gender">
        <mat-option value="">הכל</mat-option>
        <mat-option value="M">זכר</mat-option>
        <mat-option value="F">נקבה</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="compact-form compact-form-narrow" [style.visibility]="isTgselected ? 'hidden' : 'visible'">
      <mat-label>גיל מ</mat-label>
      <input matInput type="number" formControlName="ageFrom" />
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="compact-form compact-form-narrow" [style.visibility]="isTgselected ? 'hidden' : 'visible'">
      <mat-label>גיל עד</mat-label>
      <input matInput type="number" formControlName="ageTo" />
    </mat-form-field>

  </div>

</form>

@if ((isMandatoryFieldsFilled()) && isPostMessageSelected) {
  <post-message-form #child [applicationItem]="selectedApplication!" [ownerUnitId]="selectedOwnerUnitId" [regionId]="selectedOwnerRegionId" [gender]="selectedGender" [ageFrom]="selectedAgeFrom" [ageTo]="selectedAgeTo"></post-message-form>
}

@if ((isMandatoryFieldsFilled()) && isLikesForPostSelected) {
  <likes-for-post #child [applicationId]="selectedApplicationId" [ownerUnitId]="selectedOwnerUnitId" [regionId]="selectedOwnerRegionId" [gender]="selectedGender" [ageFrom]="selectedAgeFrom" [ageTo]="selectedAgeTo"></likes-for-post>
}

@if ((isMandatoryFieldsFilled()) && isCommentsOnPostSelected) {
  <comments-on-post #child [applicationId]="selectedApplicationId" [ownerUnitId]="selectedOwnerUnitId" [regionId]="selectedOwnerRegionId" [gender]="selectedGender" [ageFrom]="selectedAgeFrom" [ageTo]="selectedAgeTo"></comments-on-post>
}

@if ((isMandatoryFieldsFilled()) && isFollowUserSelected) {
  <follow-user #child [applicationId]="selectedApplicationId" [ownerUnitId]="selectedOwnerUnitId" [regionId]="selectedOwnerRegionId" [gender]="selectedGender" [ageFrom]="selectedAgeFrom" [ageTo]="selectedAgeTo"></follow-user>
}

@if (isMandatoryFieldsFilled()) {
  <div class="button-wrapper">
    <button mat-flat-button color="primary" (click)="onSendClick()" [disabled]="!isBothFormsValid()">
      <span>ש-גר !</span>
    </button>
  </div>
}

</div>